import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { IonItem, IonLabel } from '@ionic/react';
import { DateTime } from 'luxon';
import { RoundedSquareIcon } from './Icon';

export const ItemWithHours: React.FC<{ value: DateTime; icon: IconProp; title: string; color?: string }> = ({
    value,
    icon,
    title,
    color,
}) => {
    return (
        <>
            <IonItem className="bg-white">
                <RoundedSquareIcon icon={icon} color={color} />
                <IonLabel className="pl-1">{title}</IonLabel>
                <div className="mr-2 pr-2">{value.toFormat("HH'h'mm")}</div>
            </IonItem>
        </>
    );
};
